/**
 * Short driver label for the Shifts timeline: surname followed by the first-name initial ("Jan Novák" → "Novák J.").
 * Driver names come from Plánuj směny as a single "First [Middle] Last" string, so the last word is the surname.
 * @param driverName - Full driver name, or null when the shift has no driver
 */
export const formatDriverName = (driverName: string | null): string => {
  const parts = (driverName || 'N/A').trim().split(/\s+/)

  if (parts.length === 1) {
    // Single name - truncate if too long
    return parts[0].length > 8 ? parts[0].substring(0, 6) + '...' : parts[0]
  }

  const surname = parts[parts.length - 1]
  const firstNameInitial = parts[0].charAt(0)
  return `${surname} ${firstNameInitial}.`
}
